import _ from 'lodash'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import styled from 'styled-components/macro'
import useSWR from 'swr'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import {
  getDocument,
  getDocuments,
  getScenarioCards,
} from '@futures-platform/connectors/content-service-api'
import {
  getGroupById,
  getPhenomenaTypes,
} from '@futures-platform/connectors/drupal-api'
import { normalizeGroup } from '@futures-platform/connectors/drupal-api/normalize'
import { getUserId } from '@futures-platform/connectors/session'
import { getTagUrisByScenarioUuid } from '@futures-platform/connectors/tag-service-api'
import { requestTranslation } from '@futures-platform/i18n'
import { getLanguage } from '@futures-platform/i18n'
import {
  Modal, // paddingModalStyles,
} from '@futures-platform/ui'
import Tooltip from '@mui/material/Tooltip'
import Actors from './components/Actors/index'
import CardBody from './components/CardBody'
import CardFooter from './components/CardFooter'
import CardHeader from './components/CardHeader'
import checked from './components/CardHeader/checked.svg'
import g1 from './components/CardHeader/greyscale-regular@2x.png'
import ContactSupportForm from './components/ContactSupportForm'
import DevelopmentPath from './components/DevelopmentPath'
import Drivers from './components/Drivers'
import History from './components/History/index'
import MainActors from './components/MainActors'
import PDFBtn from './components/PDFBtn'
import RelatedPhenomena from './components/RelatedPhenomena'
import RelatedScenarios from './components/RelatedScenarios'
import SpotlightBtn from './components/SpotlightBtn'
import TranslationBtn from './components/TranslationBtn'
import TranslationDownBtn from './components/TranslationDownBtn'
import { WriteEditScenarioForm } from './components/WriteEditScenarioForm'
import { PhenomenaTagList } from './components/WriteEditScenarioForm/PhenomenaTagList'
import ToggleSwitcher from './components/WriteEditScenarioForm/ToggleSwitcher'
import ToggleSwitcherForTranslation from './components/WriteEditScenarioForm/ToggleSwitcherForTranslation'
import YoutubeImageEmbed from './components/YoutubeImageEmbed'
import { fetcher } from './helpers/fetcher'
// import { votingApi } from './helpers/fetcher'
import { normalisedTimeFormat } from './helpers/helpers'
import { getCloseButton } from './helpers/helpers'
import { createScenarioFuturesTableFinal } from './helpers/helpers'
import {
  getContentCardData,
  getPhenomena,
  getPhenomenaStatistic,
  getPhenomenonNewsByPhenId,
} from './helpers/phenomenonFetcher'
import { getScenarioSet, searchScenarios } from './helpers/phenomenonFetcher'
import { getFuturesTablesByScenarioSet } from './helpers/phenomenonFetcher'
import { scenarioAPIs } from './helpers/scenarioApis'
import { translatePhenomenonAlias } from './helpers/utils'
import tagIcon from './icons/tag.svg'
import { ACTIONS } from './store/Actions'
import { DataContext } from './store/GlobalState'
import { PhenEditCardStyles } from './styles'

const specialGroupsAllowedTranslation = []

//open by sid or create new from drivers, e.g. [1, -1]
const App = ({ gid: gidProp, ssid, sid, position, drivers, uri }) => {
  const gid = React.useMemo(() => Number(gidProp), [gidProp])

  NProgress.configure({ minimum: 0.1 })
  const {
    dispatch,
    state: {
      tags,
      isMainActorsDeactivated,
      isTagsDeactivated,
      isRelatedScenariosDeactivated,
      isTranslated,
      langForTransState,
      isAutoTrans,
      langListOpts,
      dataForTranslationFromCardHeader,
      dataForTranslationCardBody,
      contentTypeImageSrc,
      crowdsourced,
      isFP,
      developmentPathDOM,
      narrativeDOM,
      actorsDOM,
      driversDOM,
      pdfExportLoading,
    },
  } = useContext(DataContext)
  const history1Ref = useRef()
  const history2Ref = useRef()
  const history3Ref = useRef()
  const history4Ref = useRef()
  const history5Ref = useRef()
  const history6Ref = useRef()

  const history1Ref1 = useRef()
  const history2Ref1 = useRef()
  const history3Ref1 = useRef()
  const history4Ref1 = useRef()
  const history5Ref1 = useRef()
  const history6Ref1 = useRef()

  const [historytranslations, sethistorytranslations] = useState(null)
  const [history1, sethistory1] = useState(null)
  const [history2, sethistory2] = useState(null)
  const [history3, sethistory3] = useState(null)
  const [history4, sethistory4] = useState(null)
  const [history5, sethistory5] = useState(null)
  const [history6, sethistory6] = useState(null)
  //init with this when creating new scenario
  const scenarioTemplate = (ssid, drivers) => {
    return {
      content: {
        scenarioSetId: ssid,
        type: 'axes_of_uncertainty',
        title: '',
        summary: '',
        drivers: drivers,
        body: '',
        developmentPath: [
          { year: 2022, description: '' },
          { year: 2022, description: '' },
          { year: 2022, description: '' },
        ],
        media: {
          image: '',
          text: '',
        },
      },
    }
  }
  const userId = getUserId()

  const [openPhenEditCard, setOpenPhenEditCard] = useState(null)
  const [relatedScenarios, setrelatedScenarios] = useState(null)
  const [iconNewsFeedSection, seticonNewsFeedSection] = useState('expand_more')
  const [isOpenTransSettings, setisOpenTransSettings] = useState(false)
  const [langForTransTemp, setlangForTransTemp] = useState(langForTransState)
  const [isAutoTransTemp, setisAutoTransTemp] = useState(isAutoTrans)
  const [historyOrignalDataState, sethistoryOrignalDataState] = useState([])
  const [shouldNotShowPdfExportBtn, setshouldNotShowPdfExportBtn] =
    useState(false)
  const isNotMore495pxWidth = matchMedia('(max-width: 495px)').matches
  const isNotMore392pxWidth = matchMedia('(max-width: 392px)').matches
  const isNotMore378pxWidth = matchMedia('(max-width: 378px)').matches
  const startTimeWhenScenarioEditCardOpenedRef = useRef(null);
  const isAddedPostHogEventForScenarioCardForCloseButtonRef = useRef(false);

  const firstRender = useRef(true)
  useEffect(() => {
    if (
      firstRender.current &&
      !!langForTransState &&
      typeof isAutoTrans !== 'undefined'
    ) {
      firstRender.current = false
      if (langForTransTemp !== langForTransState) {
        setlangForTransTemp(langForTransState)
      }
      if (isAutoTransTemp !== isAutoTrans) {
        setisAutoTransTemp(isAutoTrans)
      }
      return
    }
  }, [langForTransState, isAutoTrans])

  const handleChangeIconNewsFeedSection = () => {
    if (iconNewsFeedSection === 'expand_more')
      seticonNewsFeedSection(() => `expand_less`)
    else {
      seticonNewsFeedSection(() => `expand_more`)
    }
  }
  NProgress.start()
  NProgress.set(0.2)
  const { data, mutate: mutateScenarioData } = useSWR(
    `getScenariosData=${gid}/${sid}`,
    async () => {
      try {
        if (Number(gid) !== 0) {
          const [scenarios, group, scenarioSet, phenomenaTypes] =
            await Promise.all([
              getScenarioCards({ group: gid, id: ssid }),
              getGroupById(gid || 0),
              getScenarioSet(gid, ssid),
              getPhenomenaTypes(gid),
            ])
          let scenarioCard =
            scenarios.find((s) => s.id === sid) ||
            scenarioTemplate(ssid, drivers)
          //related = not same scenario id or same drivers
          // const relatedScenarios = scenarios.filter(
          //   (s) => s.id != sid && s.content.drivers != drivers,
          // )
          if (scenarioSet?.type === 'futures_table') {
            scenarioCard.content.type = 'futures_table'
          }
          const groupNormalized = !!group?.length && normalizeGroup(group[0])
          const lastEditorId = scenarioCard.updated_by
          const creatorId = scenarioCard.created_by
          // const lastEditor = lastEditorId
          //   ? await fetcher.getUserName(lastEditorId)
          //   : ''
          const authorsRes = await Promise.allSettled([
            fetcher.getUserName(lastEditorId),
            fetcher.getUserName(creatorId),
          ])
          const lastEditor = authorsRes[0]?.value
          const creator = authorsRes[1]?.value

          let relatedScenariosRes = !!scenarioCard?.content?.related_scenarios
            ?.length
            ? await getDocuments({
                type: 'scenario-card',
                ids: scenarioCard?.content?.related_scenarios,
                fields: null,
                sortColumns: null,
              })
            : // ?.sort(function (a, b) {
              //   return (
              //     scenario?.content?.related_scenarios?.indexOf(a?.id) -
              //     scenario?.content?.related_scenarios.indexOf(b?.id)
              //   )
              // })
              []

          relatedScenariosRes = relatedScenariosRes?.sort(function (a, b) {
            return (
              scenarioCard?.content?.related_scenarios?.indexOf(a?.id) -
              scenarioCard?.content?.related_scenarios.indexOf(b?.id)
            )
          })

          return {
            scenarioCard,
            relatedScenarios: relatedScenariosRes,
            scenarioSet,
            // tags,
            lastEditor,
            lastEditorId,
            creator,
            groupNormalized,
            phenomenaTypes,
          }
        } else {
          const [scenario, group, phenomenaTypes, langListOptRes, userDataRes] =
            await Promise.all([
              getDocument({ group: 0, type: 'scenario-card', id: sid }),
              getGroupById(gid || 0),
              getPhenomenaTypes(gid || 0),
              fetcher.getListLangs(),
              fetcher.getUserNameData(userId),
            ])
          dispatch({
            type: ACTIONS.LANGFORTRANSSTATE,
            payload: userDataRes?.data?.preferredLanguage,
          })
          // const relatedScenariosRes = !!scenario?.content?.related_scenarios
          //   ?.length
          //   ? await Promise.allSettled(
          //       scenario?.content?.related_scenarios.map(async (re_sc) => {
          //         try {
          //           const res = await getDocument({
          //             group: 0,
          //             type: 'scenario-card',
          //             id: re_sc,
          //           })

          //           return res
          //         } catch (err) {
          //           console.error(`I'm down, this time. ${err}`)
          //         }
          //       }),
          //     )
          //   : []
          dispatch({
            type: ACTIONS.LANGLISTOPTIONS,
            payload: langListOptRes?.data || [],
          })
          dispatch({
            type: ACTIONS.ISAUTOTRANS,
            payload: userDataRes?.data?.isAutoTranslation,
          })
          let relatedScenariosRes = !!scenario?.content?.related_scenarios
            ?.length
            ? await getDocuments({
                type: 'scenario-card',
                ids: scenario?.content?.related_scenarios,
                fields: null,
                sortColumns: null,
              })
            : // ?.sort(function (a, b) {
              //   return (
              //     scenario?.content?.related_scenarios?.indexOf(a?.id) -
              //     scenario?.content?.related_scenarios.indexOf(b?.id)
              //   )
              // })
              []
          relatedScenariosRes = relatedScenariosRes?.sort(function (a, b) {
            return (
              scenario?.content?.related_scenarios?.indexOf(a?.id) -
              scenario?.content?.related_scenarios.indexOf(b?.id)
            )
          })

          const groupNormalized = !!group?.length && normalizeGroup(group[0])
          return {
            scenarioCard: scenario,
            // relatedScenarios: !!relatedScenariosRes?.length
            //   ? relatedScenariosRes?.map(
            //       (relatedScenario) => relatedScenario?.value,
            //     )
            //   : [],
            relatedScenarios: relatedScenariosRes,
            scenarioSet: null,
            // tags,
            lastEditor: 'FuturesPlatform',
            lastEditorId: 0,
            creator: 'FuturesPlatform',
            groupNormalized,
            phenomenaTypes,
          }
        }
      } catch (error) {}
    },
  )
  const isFirstRendered = useRef(false)

  const { data: tagsData, mutate: mutateTagsScenarioData } = useSWR(
    `tags${gid}/${sid}`,
    async () => {
      return await getTagUrisByScenarioUuid(gid, sid)
    },
  )

  const { data: relatedPhenomenaData, mutate: mutaterelatedPhenomena } = useSWR(
    `relatedPhenomena${gid}/${JSON.stringify(
      data?.scenarioCard?.content?.related_phenomena,
    )}`,
    async () => {
      return (
        (await !!data?.scenarioCard?.content?.related_phenomena?.length) &&
        getPhenomena({
          phenomena: data?.scenarioCard?.content?.related_phenomena,
          undefined,
          groups: [gid, 0],
        })
      )
    },
  )

  useEffect(() => {
    if (!window.posthog) return;
    if (!!data?.scenarioCard) {
      if (!startTimeWhenScenarioEditCardOpenedRef.current) {
        startTimeWhenScenarioEditCardOpenedRef.current = new Date()

        if (window.posthog) {
          let tracking = {
            id: data?.scenarioCard?.id,
            name: data?.scenarioCard?.content?.title,
            type: data?.scenarioCard?.content?.type,
            language: data?.scenarioCard?.language,
            publish_date: data?.scenarioCard?.created_at,
            timestamp: startTimeWhenScenarioEditCardOpenedRef.current.toISOString()
          }
          if (window.location.href.indexOf("go2.futuresplatform.com") !== -1) {
            window.posthog.capture('scenario-viewed', tracking);
          } else {
            console.log({posthog: {
              event: 'scenario-viewed',
              properties: tracking
            }});
          }
        }

      }

      if (!isAddedPostHogEventForScenarioCardForCloseButtonRef.current) {
        const closeButton = getCloseButton('side-modal', 'side-modal-close-btn', 'scenario-card-app-loaded');

        if (!!closeButton && window.posthog) {
          const triggerCloseButtonForPostHog = () => {
            isAddedPostHogEventForScenarioCardForCloseButtonRef.current = true;
            let tracking = {
              id: data?.scenarioCard?.id,
              name: data?.scenarioCard?.content?.title,
              time:(new Date().getTime() - startTimeWhenScenarioEditCardOpenedRef.current.getTime()) / 1000,
              timestamp: startTimeWhenScenarioEditCardOpenedRef.current.toISOString()
            }
            if (window.location.href.indexOf("go2.futuresplatform.com") !== -1) {
              window.posthog.capture('scenario-duration', tracking);
            } else {
              console.log({posthog: {
                event: 'scenario-duration',
                properties: tracking
              }});
            }
            closeButton.removeEventListener('click', triggerCloseButtonForPostHog);
          }
          closeButton.addEventListener('click', triggerCloseButtonForPostHog);
        }
      }
     
    }
  }, [data?.scenarioCard]);

  const [driversFuturesTables, setdriversFuturesTables] = useState(null)
  const scenarioSet = useMemo(() => {
    return data?.scenarioSet
  }, [data?.scenarioSet])

  const relatedPhenomena = React.useMemo(() => {
    const relatedContentsFiltered =
      relatedPhenomenaData?.result?.length &&
      relatedPhenomenaData?.result?.map((r_phen) => {
        const a =
          !!data?.phenomenaTypes?.length &&
          data?.phenomenaTypes?.filter(
            (type) => type?.id === r_phen?.content?.type,
          )

        if (
          !!a?.length &&
          !!a[0] &&
          a[0]?.style &&
          !!a[0]?.style?.color &&
          !!a[0]?.groupType
        ) {
          r_phen['color'] = a[0]?.style?.color
          r_phen['content-type-alias'] = 'undefined'
          r_phen['content-type-title'] = a[0]?.title || a[0]?.label
        } else {
          r_phen['color'] = 'none'
          r_phen['content-type-alias'] = a[0]?.alias
          r_phen['content-type-title'] = a[0]?.title
        }
        return r_phen
      })

    return relatedContentsFiltered?.sort(function (a, b) {
      return (
        data?.scenarioCard?.content?.related_phenomena?.indexOf(a?.id) -
        data?.scenarioCard?.content?.related_phenomena.indexOf(b?.id)
      )
    })
  }, [data, relatedPhenomenaData])

  // TAGACTIVATED: 'TAGACTIVATED',
  // MAINACTORS: 'MAINACTORS',
  // RELATEDSCENARIOS: 'RELATEDSCENARIOS',
  // isMainActorsDeactivated: false,
  // isRelatedScenariosDeactivated: false,
  // isTagsDeactivated: false,

  React.useEffect(() => {
    dispatch({
      type: ACTIONS.RELATEDSCENARIOSDATA,
      payload: data?.relatedScenarios || [],
    })
    setrelatedScenarios(() => data?.relatedScenarios)
  }, [data?.relatedScenarios, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.MAINACTORS,
      payload: data?.scenarioCard?.content?.isMainActorsDeactivated,
    })
  }, [data?.scenarioCard?.content?.isMainActorsDeactivated, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.RELATEDSCENARIOS,
      payload: data?.scenarioCard?.content?.isRelatedScenariosDeactivated,
    })
  }, [data?.scenarioCard?.content?.isRelatedScenariosDeactivated, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.TAGACTIVATED,
      payload: data?.scenarioCard?.content?.isTagsDeactivated,
    })
  }, [data?.scenarioCard?.content?.isTagsDeactivated, dispatch])

  const scenario = React.useMemo(() => {
    const a = {
      id: data?.scenarioCard?.id,
      ...data?.scenarioCard?.content,
    }
    return { ...a, image: a?.media?.image, videoText: a?.media?.text }
  }, [data?.scenarioCard?.content, data?.scenarioCard?.id])
  const langOptionList = useMemo(() => {
    if (!!langListOpts?.length) {
      return langListOpts?.sort(function (a, b) {
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }
        return 0
      })
    } else return []
  }, [langListOpts])
  useEffect(() => {
    const fetcher = async () => {
      if (true) {
        const temp1 = new Date().getTime()
        const tempDate = normalisedTimeFormat(
          data?.scenarioCard?.['created_at'],
          false,
        )
        const tempDate1 = normalisedTimeFormat(
          data?.scenarioCard?.['updated_at'],
          false,
        )
        sethistoryOrignalDataState(() => [
          {
            isMajorUpdate: true,
            description: '',
            isCreator: true,
            editorName: data?.lastEditor ?? '',
            isShown: true,
            date: tempDate,
            id: temp1,
            timestamp: new Date(data?.scenarioCard?.['created_at']).getTime(),
          },
          {
            isMajorUpdate: true,
            description: '',
            isCreator: false,
            editorName: data?.creator ?? '',
            isShown: true,
            date: tempDate1,
            id: new Date().getTime(),
            timestamp: new Date(data?.scenarioCard?.['updated_at']).getTime(),
          },
        ])
      }
    }
    if (
      !!data?.scenarioCard &&
      data?.lastEditor &&
      data?.creator &&
      !data?.scenarioCard?.content?.historyLogs?.length
    ) {
      fetcher()
    }
  }, [
    data?.scenarioCard?.content?.historyLogs,
    data?.lastEditor,
    data?.creator,
    data?.scenarioCard,
  ])
  const historyData = React.useMemo(() => {
    if (!data?.scenarioCard?.content?.historyLogs?.length) {
      const temp = [...historyOrignalDataState]
      return temp?.sort(function (a, b) {
        return b?.timestamp - a?.timestamp
      })
    }
    const temp = !!data?.scenarioCard?.content?.historyLogs?.length
      ? [...data?.scenarioCard?.content?.historyLogs]
      : []
    temp?.forEach((h) => {
      const timestampTemp = new Date(
        data?.scenarioCard?.['created_at'],
      ).getTime()
      if (!!h?.isCreator && !h?.timestamp) {
        h['timestamp'] = new Date(data?.scenarioCard?.['created_at']).getTime()
      }

      // fix if timestamp of create time is diff with created time from created_at field
      if (!!h?.isCreator && h?.timestamp !== timestampTemp) {
        h['timestamp'] = timestampTemp
      }
    })
    return temp?.sort(function (a, b) {
      return b?.timestamp - a?.timestamp
    })
  }, [data?.scenarioCard, historyOrignalDataState])

  React.useEffect(() => {
    dispatch({
      type: ACTIONS.HISTORYDATA,
      payload: [...historyData],
    })
  }, [historyData, dispatch])

  React.useEffect(() => {
    dispatch({
      type: ACTIONS.CONTENTSETTINGS,
      payload: data?.groupNormalized,
    })
  }, [data?.groupNormalized, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.TAGS,
      payload: tagsData,
    })
    dispatch({
      type: ACTIONS.ORIGNALTAGS,
      payload: tagsData,
    })
  }, [tagsData, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.DEVPATHS,
      payload: data?.scenarioCard?.content?.developmentPath,
    })
  }, [data?.scenarioCard?.content?.developmentPath, dispatch])

  React.useEffect(() => {
    dispatch({
      type: ACTIONS.ACTORS,
      payload: data?.scenarioCard?.content?.actors,
    })
  }, [data?.scenarioCard?.content?.actors, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.VERBALDRIVERS,
      payload: data?.scenarioCard?.content?.verbalDrivers,
    })
  }, [data?.scenarioCard?.content?.verbalDrivers, dispatch])
  React.useEffect(() => {
    dispatch({
      type: ACTIONS.SCENARIOSET,
      payload: data?.scenarioSet,
    })
  }, [data?.scenarioSet, dispatch])
  !!data && NProgress.set(0.5)
  const canEditContentCard = useMemo(() => {
    if (Number(gid) === 0) {
      return !!data?.groupNormalized?.canEditPublic
    } else {
      return !!data?.groupNormalized?.canEdit
    }
  }, [
    data?.groupNormalized?.canEdit,
    data?.groupNormalized?.canEditPublic,
    gid,
  ])

  !!data && NProgress.done(true)
  !!data && NProgress.remove()
  const seletecTransHandler = (e) => {
    const label = e?.target?.innerText
    const selectedFilter = _.find(langOptionList, {
      label: label,
    })
    if (langForTransTemp === selectedFilter?.value) {
      setlangForTransTemp(() => null)
      setisAutoTransTemp(() => false)
    } else {
      setlangForTransTemp(() => selectedFilter?.value)
    }

    // dispatch({
    //   type: ACTIONS.LANGFORTRANSSTATE,
    //   payload: selectedFilter,
    // });
  }
  const cancelSetAutoTransSettingHandler = () => {
    setisOpenTransSettings(false)
    setlangForTransTemp(() => langForTransState)
    setisAutoTransTemp(() => isAutoTrans)
  }

  const doneSetAutoTransSettingHandler = async () => {
    const payload = {
      preferred_language: langForTransTemp ?? null,
      is_auto_translation: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    }

    await fetcher.editPreferredTrans(userId, payload)
    setisOpenTransSettings(false)
    dispatch({
      type: ACTIONS.LANGFORTRANSSTATE,
      payload: langForTransTemp ?? null,
    })
    dispatch({
      type: ACTIONS.ISAUTOTRANS,
      payload: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    })

    // When user clicks Done btn, the content of card should be translated to the target languague,
    // because the user did indicate that he/she wants to translate the card when he/she selected
    // the target lang. So when clicking done, the content card should be translated, but this case
    // is NOT the auto-translation, so should NOT set isAutoTransTemp variable and call editPreferredTrans api
    // with payload is_auto_translation = 1 to set to auto-translation => just translating the content of card.
    if (!!langForTransTemp) {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: true,
      })
    } else {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: false,
      })
    }
    setshouldNotShowPdfExportBtn(true)
  }
  const setAutoTransByOnDefaultHandler = () => {
    setisAutoTransTemp(() => !isAutoTransTemp)
    // dispatch({
    //   type: ACTIONS.ISAUTOTRANS,
    //   payload: !isAutoTrans,
    // });
  }

  const isThisGroupTranslationAllowed = React.useMemo(() => {
    const temp = specialGroupsAllowedTranslation.find(
      (group) => group === Number(gid),
    )
    return !!temp
  }, [gid])

  useEffect(() => {
    const fetcherData = async () => {
      const history6Temp = history6 ?? history6Ref1.current
      const [res1, res2, res3, res4, res5, res6] = await Promise.all([
        !!history1Ref1.current &&
          history1 &&
          fetcher.translation(
            'en',
            langForTransState,
            history1 ?? history1Ref1.current,
          ),
        !!history2Ref1.current &&
          history2 &&
          fetcher.translation(
            'en',
            langForTransState,
            history2 ?? history2Ref1.current,
          ),
        !!history3Ref1.current &&
          history3 &&
          fetcher.translation(
            'en',
            langForTransState,
            history3 ?? history3Ref1.current,
          ),
        (!!history4 || !!history4Ref1.current) &&
          fetcher.translation(
            'en',
            langForTransState,
            history4 ?? history4Ref1.current,
          ),
        (!!history5 || !!history5Ref1.current) &&
          fetcher.translation(
            'en',
            langForTransState,
            history5 ?? history5Ref1.current,
          ),
        !!history6Temp &&
          (await Promise.all(
            history6Temp?.map((child) => {
              if (!!child) {
                return fetcher.translation(
                  'en',
                  langForTransState,
                  child?.innerHTML,
                )
              }
            }),
          )),
      ])

      sethistorytranslations(() => {
        return {
          res1,
          res2,
          res3,
          res4,
          res5,
          res6,
        }
      })
    }
    !!isTranslated && fetcherData()
  }, [
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
    isTranslated,
    langForTransState,
  ])

  useEffect(() => {
    if (!!historyData && !!historyData?.length) {
      if (!isTranslated) {
        if (!!history1Ref.current?.innerHTML && !history1Ref1.current) {
          history1Ref1.current = history1Ref.current?.innerHTML
        }
        if (!!history2Ref.current?.innerHTML && !history2Ref1.current) {
          history2Ref1.current = history2Ref.current?.innerHTML
        }
        if (!!history3Ref.current?.innerHTML && !history3Ref1.current) {
          history3Ref1.current = history3Ref.current?.innerHTML
        }
        if (!!history4Ref.current?.innerHTML && !history4Ref1.current) {
          history4Ref1.current = history4Ref.current?.innerHTML
        }
        if (!!history6Ref.current && !history6Ref1.current) {
          const historyList = Array.from(
            document?.querySelectorAll('.firstPartHistoryRow') ?? [],
          )

          //////////=>current version code
          history6Ref1.current = historyList
        }
        // if (!!history6Ref.current?.innerHTML && !history6Ref1.current) {
        //   history6Ref1.current = history6Ref.current?.innerHTML;
        // }
        !!history1Ref1.current &&
          !history1 &&
          sethistory1(() => history1Ref1.current)
        !!history2Ref1.current &&
          !history2 &&
          sethistory2(() => history2Ref1.current)
        !!history3Ref1.current &&
          !history3 &&
          sethistory3(() => history3Ref1.current)
        !!history4Ref1.current &&
          !history4 &&
          sethistory4(() => history4Ref1.current)
        // !!history5Ref1.current &&
        //   !history5 &&
        //   sethistory5(() => history5Ref1.current);
        !!history6Ref1.current &&
          !history6 &&
          sethistory6(() => history6Ref1.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD1,
        //   payload: true
        // })
      }
    }
  }, [
    isTranslated,
    historyData,
    dispatch,
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
  ])

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await getFuturesTablesByScenarioSet(scenarioSet?.id)

      const futuresTables = createScenarioFuturesTableFinal(
        res1?.data[0]?.matrix,
        [scenario],
      )
      const returningData = !!futuresTables?.length
        ? futuresTables?.filter((ft) => ft?.id === scenario?.id)
        : []

      setdriversFuturesTables(() =>
        !!returningData?.length ? returningData[0] : null,
      )
      dispatch({
        type: ACTIONS.DRIVERSFUTURESTABLES,
        payload: !!returningData?.length ? returningData[0] : null,
      })
    }
    scenarioSet?.id && fetcher()
  }, [scenarioSet?.id, scenario, dispatch])

  useEffect(() => {
    if (!!shouldNotShowPdfExportBtn) {
      setTimeout(() => {
        setshouldNotShowPdfExportBtn(false)
      }, 5000)
    }
  }, [shouldNotShowPdfExportBtn])

  const isRTL = useMemo(() => {
    const rtlLangs = ['ar', 'he', 'fa', 'ur', 'ps', 'ckb', 'dv', 'yi']
    return rtlLangs.includes(langForTransState)
  }, [langForTransState])

  useEffect(() => {
    dispatch({
      type: ACTIONS.ISRTL,
      payload: isRTL,
    })
  }, [isRTL, dispatch])
  useEffect(() => {
    if (
      !!langForTransState &&
      !!isAutoTrans &&
      !!data?.scenarioCard &&
      !isTranslated &&
      !isFirstRendered.current &&
      (Number(gid) === 0 || gid === 0 || !!isThisGroupTranslationAllowed)
    ) {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.ISTRANSLATED,
          payload: true,
        })
      }, 2000)
      isFirstRendered.current = true
    }
  }, [
    data?.scenarioCard,
    dispatch,
    isAutoTrans,
    isTranslated,
    langForTransState,
    gid,
    isThisGroupTranslationAllowed,
  ])

  return (
    <div>
      {!!isOpenTransSettings && (
        <Modal
          isOpen={isOpenTransSettings}
          onRequestClose={() => setisOpenTransSettings(false)}
          style={PhenEditCardStyles}
          ariaHideApp={false}>
          <div
            style={{
              padding: '16px',
            }}>
            <h3
              style={{
                marginTop: '1rem',
              }}>
              Select you preferred language for translations
            </h3>
            <LangOptWRapper
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}>
              {!!langOptionList?.length &&
                langOptionList?.map((langOpt, i) => {
                  return (
                    <LangOpt
                      key={i}
                      data-value={langOpt?.value}
                      onClick={seletecTransHandler}
                      isSelected={langForTransTemp === langOpt?.value}>
                      {langOpt?.label}
                      {langForTransTemp === langOpt?.value && (
                        <EditButton
                          style={{
                            width: 12,
                          }}
                          src={checked}
                          // onClick={() => {
                          //   dispatch({
                          //     type: ACTIONS.ISTRANSLATED,
                          //     payload: false,
                          //   });
                          // }}
                        />
                      )}
                    </LangOpt>
                  )
                })}
            </LangOptWRapper>
            <AutoTransWrapper>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: 'calc(50% - 4.6px)',
                }}>
                <h5
                  style={{
                    margin: 0,
                  }}>
                  Set auto-translations on by default?
                </h5>
                <ToggleSwitcherForTranslation
                  checked={!langForTransTemp ? false : isAutoTransTemp}
                  toggleHandler={setAutoTransByOnDefaultHandler}
                />
              </div>
              <p
                style={{
                  fontSize: '13px',
                  marginTop: '1rem',
                  marginBottom: '1rem',
                }}>
                If you switch this on, all content cards created by the Futures
                Platform are automatically translated to your preferred
                language.
              </p>
              {true && (
                <EditButton
                  style={{
                    height: 14,
                    margin: 0,
                  }}
                  src={g1}
                />
              )}
            </AutoTransWrapper>
            <CTAsWrapper>
              {/* <AskForMoreLangs className="btn btn-sm btn-outline-secondary">
                ASK FOR MORE LANGUAGES...
              </AskForMoreLangs> */}
              <ContactSupportForm />
              <div>
                <button
                  style={{
                    boxShadow: 'none',
                    border: 'none',
                  }}
                  className="btn btn-lg btn-plain-gray"
                  onClick={() => {
                    cancelSetAutoTransSettingHandler()
                  }}>
                  CANCEL
                </button>
                <button
                  style={{
                    marginLeft: '16px',
                  }}
                  className="btn btn-lg btn-primary"
                  onClick={() => {
                    doneSetAutoTransSettingHandler()
                  }}
                  type="submit">
                  DONE
                </button>
              </div>
            </CTAsWrapper>
          </div>
        </Modal>
      )}
      {!!data && (
        <div
          className="container p_4"
          style={{
            background: '#fff',
            color: '#333',
            paddingLeft: '5%',
            paddingRight: '5%',
            paddingTop: '1rem',
            minWidth: '100%',
          }}>
          <CardHeader scenario={scenario} />

          <div
            style={{
              display: 'flex',
              justifyContent:
                (Number(gid) === 0 ||
                  gid === 0 ||
                  !!isThisGroupTranslationAllowed) &&
                data?.scenarioCard?.language === 'en'
                  ? 'space-between'
                  : 'flex-end',
              alignItems: 'center',
              flexWrap: 'wrap',
              marginBottom: '0.6875rem',
            }}>
            {(Number(gid) === 0 ||
              gid === 0 ||
              !!isThisGroupTranslationAllowed) &&
              data?.scenarioCard?.language === 'en' && (
                <div
                  id="translation-btn-wrapper"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}>
                  {data?.scenarioCard?.language === 'en' && (
                    <div
                      data-langtarget={langForTransState}
                      data-uri={uri}
                      id="trans-btn"
                      style={{
                        // height: '24px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        if (!isTranslated) {
                          !!langForTransState
                            ? dispatch({
                                type: ACTIONS.ISTRANSLATED,
                                payload: true,
                              })
                            : setisOpenTransSettings(true)

                          !!langForTransState &&
                            setshouldNotShowPdfExportBtn(true)
                        } else {
                          dispatch({
                            type: ACTIONS.ISTRANSLATED,
                            payload: false,
                          })
                          setshouldNotShowPdfExportBtn(true)
                        }
                      }}>
                      <TranslationBtn
                        isAuthed={true}
                        isNewsBookMarked={isTranslated}
                        // isNewsBookMarked={isNewsBookMarked}
                      />
                    </div>
                  )}

                  {/* {!isTranslated && langRadar === "en" && (
                <EditButton
                  id='trans-btn'
                  style={{
                    height: '24px'
                  }}
                  data-langtarget={langForTransState}
                  data-uri={uri}
                  src={trans}
                  onClick={() =>
                    !!langForTransState ?
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: true,
                    }) : setisOpenTransSettings(true)
                  }
                />
              )}
              {!!isTranslated && langRadar === "en" && (
                <EditButton
                style={{
                  height: '24px'
                }}
                  src={orginalTrans}
                  onClick={() => {
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: false,
                    });
                  }}
                />
              )} */}
                  {data?.scenarioCard?.language === 'en' && (
                    <div
                      onClick={() => setisOpenTransSettings(() => true)}
                      style={{
                        marginLeft: '0.25rem',
                      }}>
                      <TranslationDownBtn
                        isAuthed={true}
                        isNewsBookMarked={isOpenTransSettings}
                      />
                    </div>
                  )}
                </div>
              )}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                // width: "7.25rem",
                width: 'fit-content',
                gap: '0.5rem',
                // marginTop: !!isNotMore392pxWidth ? '0.8125rem' : 0,
                marginTop: 0,
              }}>
              <div
                onClick={(e) => {
                  window.open('/spotlight/' + sid + '?content=scenario')
                }}>
                <SpotlightBtn isAuthed={true} isNewsBookMarked={false} />
              </div>
              {true && (
                <Tooltip
                  placement="bottom-end"
                  title={requestTranslation('pdfExportTooltip')}>
                  <div
                    onClick={async (e) => {
                      if (!!shouldNotShowPdfExportBtn || pdfExportLoading)
                        return

                      // Set loading state to true
                      dispatch({
                        type: 'SET_PDF_EXPORT_LOADING',
                        payload: true,
                      })

                      let payloadPDFExporter
                      const today = new Date()
                      const months = [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                      ]
                      const formattedDate = `${today.getDate()} ${
                        months[today.getMonth()]
                      } ${today.getFullYear()}`

                      const resFooterTranslationForPDFExporter = !!isTranslated
                        ? await fetcher.translation(
                            'en',
                            langForTransState,
                            'Exported from Futures Platform on ' +
                              formattedDate,
                          )
                        : 'Exported from Futures Platform on ' + formattedDate

                      let inStructions = {
                        header: 'Instructions',
                        items: [
                          {
                            label: 'Fill in the following field',
                            value:
                              data?.scenarioSet?.instructions
                                ?.fieldInstructions,
                          },
                          {
                            label: 'Length of narrative',
                            value:
                              data?.scenarioSet?.instructions?.lengthNarrative,
                          },
                          {
                            label: 'Number of the paragraphs',
                            value:
                              data?.scenarioSet?.instructions
                                ?.numberOfParagraphs,
                          },
                          {
                            label: 'Perspectives',
                            value:
                              data?.scenarioSet?.instructions?.perspectives,
                          },
                          {
                            label: 'Writings style',
                            value:
                              data?.scenarioSet?.instructions?.writingStyles,
                          },
                          {
                            label: 'Suggested editors',
                            value:
                              data?.scenarioSet?.instructions
                                ?.writerSuggestions,
                          },
                          {
                            label: 'More instructions to the writers',
                            value:
                              data?.scenarioSet?.instructions?.instructions,
                          },
                        ],
                      }

                      if (data?.scenarioSet?.instructions) {
                        if (isTranslated) {
                          try {
                            // Create an array of promises for translations
                            const translationPromises = []

                            // Add the header translation promise if it exists
                            if (inStructions.header) {
                              translationPromises.push(
                                fetcher.translation(
                                  'en',
                                  langForTransState,
                                  inStructions.header,
                                ),
                              )
                            }

                            // Add promises for each item translation
                            inStructions.items.forEach((item) => {
                              if (item?.value) {
                                translationPromises.push(
                                  fetcher.translation(
                                    'en',
                                    langForTransState,
                                    item.value,
                                  ),
                                )
                              } else {
                                translationPromises.push(Promise.resolve(null)) // Handle empty values
                              }
                            })

                            // Resolve all translations
                            const translations = await Promise.all(
                              translationPromises,
                            )

                            // Update inStructions
                            inStructions.header = translations[0] // Set the translated header

                            // Update items with the corresponding translation results
                            inStructions.items = inStructions.items.map(
                              (item, index) => {
                                return {
                                  ...item,
                                  value: translations[index + 1], // Set the value to the corresponding translation response
                                }
                              },
                            )
                          } catch (error) {
                            // Reset translation loading state
                            dispatch({
                              type: 'SET_PDF_EXPORT_LOADING',
                              payload: false,
                            })
                            console.error('Translation error:', error)
                          } finally {
                          }
                        }
                      }

                      if (!isTranslated) {
                        payloadPDFExporter = {
                          langcode: data?.scenarioCard?.language || 'en',
                          is_fp: Number(gid) === 0 ? true : false,
                          instructions: data?.scenarioSet?.instructions
                            ? inStructions
                            : null,
                          development_path: developmentPathDOM ?? null,
                          narrative: narrativeDOM ?? null,
                          actors: actorsDOM ?? null,
                          drivers: driversDOM ?? null,
                          type: 'scenario',
                          subtitle: 'SCENARIO',
                          title: data?.scenarioCard?.content?.title || null,
                          crowd_source: crowdsourced?.crowdsourced ?? null,
                          content_type_icon:
                            contentTypeImageSrc?.contentTypeImageSrc || null,
                          content_type: 'Scenario',
                          summary: data?.scenarioCard?.content?.summary || null,
                          image:
                            data?.scenarioCard?.content?.media?.image || null,
                          time_range: !!data?.scenarioCard?.content?.time_range
                            ?.min
                            ? `${data?.scenarioCard?.content?.time_range?.min} - ${data?.scenarioCard?.content?.time_range?.max}`
                            : null,
                          body: data?.scenarioCard?.content?.body || null,
                          export_date: formattedDate,
                          footer:
                            resFooterTranslationForPDFExporter ||
                            resFooterTranslationForPDFExporter?.data ||
                            null,
                          // phenomenon: {
                          //   ...data?.phenomenon?.data,
                          //   contentTypeImageSrc,
                          //   isTranslated: false,
                          //   crowdsourced: crowdsourced,
                          //   isFP: isFP,
                          // }
                        }
                      } else {
                        payloadPDFExporter = {
                          langcode: langForTransState || 'en',
                          instructions: data?.scenarioSet?.instructions
                            ? inStructions
                            : null,
                          development_path: developmentPathDOM ?? null,
                          narrative: narrativeDOM ?? null,
                          actors: actorsDOM ?? null,
                          drivers: driversDOM ?? null,
                          is_fp: Number(gid) === 0 ? true : false,
                          type: 'scenario',
                          title:
                            dataForTranslationFromCardHeader?.title || null,
                          subtitle: 'SCENARIO',
                          crowd_source: crowdsourced?.crowdsourced ?? null,
                          content_type_icon:
                            contentTypeImageSrc?.contentTypeImageSrc || null,
                          content_type:
                            dataForTranslationFromCardHeader?.typeCardName ||
                            null,
                          summary:
                            dataForTranslationFromCardHeader?.summary || null,
                          image:
                            data?.scenarioCard?.content?.media?.image || null,
                          time_range:
                            dataForTranslationFromCardHeader?.timeRange || null,
                          body: dataForTranslationCardBody?.body || null,
                          export_date: formattedDate,
                          footer:
                            resFooterTranslationForPDFExporter?.data ||
                            resFooterTranslationForPDFExporter ||
                            null,
                          // phenomenon: {
                          //   ...data?.phenomenon?.data,
                          //   isTranslated: true,
                          //   contentTypeImageSrc,
                          //   dataForTranslationFromCardHeader: dataForTranslationFromCardHeader,
                          //   dataForTranslationCardBody: dataForTranslationCardBody,
                          //   crowdsourced: crowdsourced,
                          //   isFP: isFP,
                          // }
                        }
                      }

                      try {
                        const pdfExporterRes = await fetcher.exportPdfReport(
                          payloadPDFExporter,
                        )

                        // The PDF should already be opened in a new window by the exportPdfReport function
                        // No need to create a blob and open it again
                        if (!pdfExporterRes.success) {
                          console.error(
                            'Failed to export PDF:',
                            pdfExporterRes.error,
                          )
                        }
                      } catch (error) {
                        console.error('Error exporting PDF:', error)
                      } finally {
                        dispatch({
                          type: 'SET_PDF_EXPORT_LOADING',
                          payload: false,
                        })
                      }

                      dispatch({
                        type: 'SET_PDF_EXPORT_LOADING',
                        payload: false,
                      })
                    }}>
                    <PDFBtn
                      isAuthed={true}
                      isNewsBookMarked={pdfExportLoading}
                      isDisabled={!!shouldNotShowPdfExportBtn}
                    />
                  </div>
                </Tooltip>
              )}

              {/* <div
                  style={{
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                  onClick={(e) => {
                    window.open("/spotlight/" + pid + "?content=scenario");
                  }}
                >
                  <ShareBtn isAuthed={true} isNewsBookMarked={false} />
                </div> */}

              {/* <NewsSharesWrapper
                  style={{
                    position: "relative",
                  }}
                >
                  {!!isSharedModalOpened && (
                    <ShareModalWrapper ref={shareWrapperRef}>
                      <SocialSharesWrapper>
                        <SocialShare
                          id="shared-by-linkedin"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-linkedin" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <LinkedinShareButton
                            url={hostname + "/spotlight/" + pid}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-linkedin"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in LinkedIn"
                                : "Jaa LinkedInissäI"}
                            </div>
                          </LinkedinShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-twitter"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-twitter" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <TwitterShareButton
                            url={hostname + "/spotlight/" + pid}
                            title={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-twitter"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Twitter"
                                : "Jaa Twitterissä"}
                            </div>
                          </TwitterShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-facebook"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-facebook" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <FacebookShareButton
                            url={hostname + "/spotlight/" + pid}
                            quote={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-facebook"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Facebook"
                                : "Jaa Facebookissa"}
                            </div>
                          </FacebookShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-email"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-email" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <EmailShareButton
                            IsBodyHtml={true}
                            // url={hostname + '/spotlight/' + newsItem?.id}
                            url={""}
                            subject={`[Shared from FP:] ${data?.phenomenon?.data?.content?.title}`}
                            body={`Hi!

A new way to dive into the news! Click this link to open this article in the Spotlight by Futures Platform:

${hostname}/spotlight/${pid}`}
                            // className="Demo__some-network__share-button"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-mail"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share by Email"
                                : "Jaa Sähköpostitse"}
                            </div>
                          </EmailShareButton>
                        </SocialShare>
                      </SocialSharesWrapper>
                    </ShareModalWrapper>
                  )}
                  <div
                    onClick={(event) =>
                      shareSocialBtnsHandler(data?.phenomenon?.data, event)
                    }
                  >
                    <ShareBtn
                      isAuthed={true}
                      isNewsBookMarked={isSharedModalOpened}
                    />
                  </div>
                </NewsSharesWrapper> */}

              {/* <div onClick={newsBookmarkHandler} ref={sharedBtnRef}>
                  <BookmarkBtn
                    isAuthed={true}
                    isNewsBookMarked={isNewsBookMarked}
                  />
                </div> */}
            </div>
          </div>

          <YoutubeImageEmbed content={scenario} />
          <Drivers
            drivers={data?.scenarioSet?.drivers}
            driversFuturesTables={driversFuturesTables}
            scenario={scenario}
            scenarioSet={data?.scenarioSet}
          />
          <CardBody card={scenario} />

          <DevelopmentPath developmentPath={scenario.developmentPath} />
          {!isMainActorsDeactivated && <Actors gid={gid} scenario={scenario} />}

          {true && (
            <RelatedPhenomena
              className="relatedPhenomena-content-card"
              phenomena={relatedPhenomena}
              gid={gid}

              // lang={langRadar}
            />
          )}
          {!isRelatedScenariosDeactivated && (
            <RelatedScenarios
              scenarioSetId={data?.scenarioSet?.id}
              gid={gid}
              relatedScenarios={relatedScenarios}
            />
          )}

          {!isTagsDeactivated &&
            !!Array.from(
              !!tags?.length ? tags : !!tagsData?.length ? tagsData : [],
            )?.length && (
              <>
                {' '}
                <>
                  <div
                    style={{
                      background: '#e8ebeb',
                      width: '100%',
                      height: '2px',
                      marginBottom: '30px',
                    }}></div>
                  <div
                    style={{
                      display: 'flex',
                    }}>
                    <img
                      style={{
                        marginTop: '5px',
                        marginRight: '12px',
                      }}
                      src={tagIcon}
                    />
                    <PhenomenaTagList
                      scenario={{
                        id: scenario.id,
                        tags: Array.from(
                          !!tags?.length
                            ? tags
                            : !!tagsData?.length
                            ? tagsData
                            : [],
                        ),
                      }}
                      language={getLanguage() || 'en'}
                      gid={gid}
                    />
                  </div>
                </>
              </>
            )}
          {/* {true && <History card={scenario} />} */}
          <div
            className="modal-form-section"
            style={{
              marginTop: '21px',
              marginBottom: '21px',
              paddingTop: '16px',
              paddingBottom: '16px',
              marginLeft: 'calc(-5% - 4px)',
              marginRight: 'calc(-5% - 4px)',
              paddingLeft: 'calc( 5% + 4px)',
              paddingRight: 'calc( 5% + 4px)',
              width: 'calc(110% + 8px)',
              backgroundColor: '#f1f3f3',
              position: 'relative',
            }}>
            <HorizontalLine></HorizontalLine>
            <Dropdown
              className="dropdown-toggle d-flex align-items-center justify-content-between"
              type="button"
              // data-toggle="collapse"
              data-target="#collapsenews"
              aria-expanded={
                iconNewsFeedSection === 'expand_more' ? 'true' : 'false'
              }
              style={{
                cursor: 'pointer',
                whiteSpace: 'unset',
                alignItems: 'start !important',
              }}
              id="history-dropdown"
              onClick={handleChangeIconNewsFeedSection}>
              <div
                id="history-autor-date-wrapper"
                style={{
                  width: '60%',
                  // display: 'flex',
                }}>
                {!isTranslated && (
                  <p
                    ref={history1Ref}
                    style={{
                      margin: 0,
                      color: 'black',
                      fontWeight: '100',
                      wordBreak: 'break-word',
                      marginRight: '2.5px',
                    }}>{`${
                    historyData[0]?.isCreator
                      ? requestTranslation('Created')
                      : requestTranslation('lastModified')
                  } by`}</p>
                )}
                {!!isTranslated && (
                  <p
                    ref={history1Ref}
                    dangerouslySetInnerHTML={{
                      __html: historytranslations?.res1?.data,
                    }}
                    style={{
                      margin: 0,
                      color: 'black',
                      fontWeight: '100',
                      wordBreak: 'break-word',
                      marginRight: '2.5px',
                    }}></p>
                )}

                <p
                  style={{
                    margin: 0,
                    color: 'black',
                    fontWeight: '100',
                    wordBreak: 'break-word',
                    marginRight: '2.5px',
                  }}>{`${
                  Number(gid) !== 0
                    ? historyData[0]?.editorName
                    : 'Futures Platform'
                }`}</p>
                {!isTranslated && (
                  <p
                    ref={history2Ref}
                    style={{
                      margin: 0,
                      color: 'black',
                      fontWeight: '100',
                      wordBreak: 'break-word',
                      marginRight: '2.5px',
                    }}>
                    on
                  </p>
                )}
                {!!isTranslated && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: historytranslations?.res2?.data,
                    }}
                    ref={history2Ref}
                    style={{
                      margin: 0,
                      color: 'black',
                      fontWeight: '100',
                      wordBreak: 'break-word',
                      marginRight: '2.5px',
                      textTransform: 'lowercase',
                    }}></p>
                )}
                <p
                  style={{
                    margin: 0,
                    color: 'black',
                    fontWeight: '100',
                    wordBreak: 'break-word',
                  }}>{`${historyData[0]?.date}`}</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                {!isTranslated && (
                  <p
                    ref={history3Ref}
                    style={{
                      margin: 0,
                      marginRight: '4px',
                      fontWeight: '100',
                      width: 'fit-content',
                    }}>
                    {iconNewsFeedSection === 'expand_more'
                      ? requestTranslation('ShowHistory')
                      : requestTranslation('HideHistory')}
                  </p>
                )}
                {!!isTranslated && (
                  <p
                    ref={history3Ref}
                    style={{
                      margin: 0,
                      marginRight: '4px',
                      fontWeight: '100',
                      width: 'fit-content',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: historytranslations?.res3?.data,
                    }}></p>
                )}
                <i className="material-icons">{iconNewsFeedSection}</i>
              </div>
            </Dropdown>
            <div
              id="collapsenews"
              className={`${
                iconNewsFeedSection === 'expand_more'
                  ? ' collapse show mt-4'
                  : ' collapse mt-4'
              }`}>
              {!isTranslated && (
                <h3 className="mb-4" ref={history4Ref}>
                  {requestTranslation('Historyandchangelog')}
                  {/* <DropdownValue></DropdownValue> */}
                </h3>
              )}
              {!!isTranslated && (
                <h3
                  className="mb-4"
                  ref={history4Ref}
                  dangerouslySetInnerHTML={{
                    __html: historytranslations?.res4?.data,
                  }}></h3>
              )}
              {!!historyData?.length &&
                historyData?.map((history, i) => {
                  return (
                    <>
                      {!!history?.isShown && (
                        <div
                          key={i}
                          style={{
                            marginBottom: '16px',
                            marginLeft: '24px',
                            display: 'flex',
                            flexWrap: 'wrap',
                          }}>
                          {!isTranslated && (
                            <p
                              ref={history6Ref}
                              className="firstPartHistoryRow"
                              style={{
                                margin: 0,
                                color: '#637282',
                                marginRight: '2.5px',
                              }}>{`${
                              history?.isCreator
                                ? requestTranslation('Created')
                                : requestTranslation('Edited')
                            } ${requestTranslation('on')} ${
                              history?.date
                            }  ${requestTranslation('by')}`}</p>
                          )}
                          {!!isTranslated && (
                            <p
                              ref={history6Ref}
                              dangerouslySetInnerHTML={{
                                __html: historytranslations?.res6?.[i]?.data,
                              }}
                              style={{
                                margin: 0,
                                color: '#637282',
                                marginRight: '2.5px',
                              }}></p>
                          )}
                          <p
                            style={{
                              margin: 0,
                              color: '#637282',
                              marginRight: '3px',
                            }}>{`${
                            Number(gid) !== 0
                              ? history?.editorName
                              : 'Futures Platform'
                          }`}</p>

                          <p
                            // ref={history5Ref}
                            style={{
                              margin: 0,
                              fontWeight: 500,
                            }}>
                            {history?.description}
                          </p>
                        </div>
                      )}
                    </>
                  )
                })}
            </div>
            <CardFooter
              isNotInEditMode={true}
              data={data}
              scenarioId={data.scenarioCard?.id}
              lang={getLanguage() || 'en'}
              onOpenPhenEditCard={() => setOpenPhenEditCard(true)}
              canEditContentCard={canEditContentCard}
              gid={gid}
              isEditBtnShown={!!canEditContentCard}
            />
          </div>
          {/* historyOrignalDataState */}

          {!!openPhenEditCard && (
            <Modal
              isOpen={openPhenEditCard}
              onRequestClose={() => setOpenPhenEditCard(false)}
              style={PhenEditCardStyles}
              ariaHideApp={false}>
              <WriteEditScenarioForm
                driversFuturesTables={driversFuturesTables}
                // historyData={historyData}
                language={data?.scenarioCard?.language || 'en'}
                mutaterelatedPhenomena={mutaterelatedPhenomena}
                relatedPhenomena={relatedPhenomena}
                lastEditorId={data?.lastEditorId}
                gid={gid}
                data={data}
                relatedScenarios={relatedScenarios}
                scenario={scenario}
                scenarioId={data.scenarioCard?.id}
                scenarioSet={data.scenarioSet}
                scenarios={data.scenarios}
                tagList={tagsData || tags || []}
                urlSWR={`getAllCommentsByPhenId=${gid}/${sid}`}
                mutateScenarioData={mutateScenarioData}
                mutateTagsScenarioData={mutateTagsScenarioData}
                onSubmit={() => {
                  setOpenPhenEditCard(false)
                  // const temp = [...devPaths]
                  // temp?.forEach((dp) => {
                  //   dp.isSubmited = true
                  // })
                  // dispatch({
                  //   type: ACTIONS.DEVPATHS,
                  //   payload: temp,
                  // })
                }}
                onCancel={() => {
                  setOpenPhenEditCard(false)
                  dispatch({
                    type: ACTIONS.DEVPATHS,
                    payload: data?.scenarioCard?.content?.developmentPath,
                  })
                  dispatch({
                    type: ACTIONS.MAINACTORS,
                    payload:
                      data?.scenarioCard?.content?.isMainActorsDeactivated,
                  })
                  dispatch({
                    type: ACTIONS.RELATEDSCENARIOS,
                    payload:
                      data?.scenarioCard?.content
                        ?.isRelatedScenariosDeactivated,
                  })
                  dispatch({
                    type: ACTIONS.TAGACTIVATED,
                    payload: data?.scenarioCard?.content?.isTagsDeactivated,
                  })
                }}
              />
            </Modal>
          )}
        </div>
      )}
    </div>
  )
}
export default App

export const DropdownValue = styled.span`
  font-size: 16px;
`

export const Dropdown = styled.div`
  -webkit-appearance: none;
  &:after {
    display: none;
  }
`
const HorizontalLine = styled.div`
  margin-left: calc(-5% - 4px);
  margin-right: calc(-5% - 4px);
  width: calc(100% + 8px);
  height: 2px;
  position: absolute;
  top: 0;
  background-color: #f6f4f7;
`
export const LangOptWRapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const LangOpt = styled.div`
  // isSelected #5ea236
  font-weight: 400;
  color: ${(props) => (!!props.isSelected ? 'white' : 'black')};
  background: ${(props) => (!!props.isSelected ? '#6fbf40' : 'transparent')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(50% - 4.6px);
  border: 1px solid rgb(118 118 118 / 50%);
  padding: 14px;
  margin-bottom: 6px;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 14px;
  font-family: L10, Roboto, 'Helvetica Neue', Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  &:nth-child(odd) {
    margin-right: 3px;
  }
  &:nth-child(even) {
    margin-left: 3px;
  }
  :hover {
    background: ${(props) => (!!props.isSelected ? '#5ea236' : '#aaaaaa36')};
  }
`
export const EditButton = styled.img`
  cursor: pointer;
  margin-left: 16px;
  height: 24px;
  :hover {
    opacity: 0.8;
  }
`
export const AutoTransWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`
export const CTAsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`
